import * as yup from 'yup';
import ContactFormEntry from '../models/ContactFormEntry';
import FormError from '../../../models/FormError';

export default class FormValidationService {

    public translatedErrorMessages : any;

    private nationalSecurityNumberRegex: RegExp = /^([0-9]{2})\.(0[1-9]|1[0-2])\.(0[1-9]|[12]\d|3[01])\-([0-9]{3})\.([0-9]{2})$/;

    private validationSchema: yup.ObjectSchema = yup.object().shape({
        subject: yup.object().required("required_field"),
        question: yup.string().required("required_field").max(5000, "field_to_long"),
        firstname: yup.string().required("required_field").max(500, "field_to_long"),
        lastname: yup.string().required("required_field").max(500, "field_to_long"),
        email: yup.string().required("required_field").email("invalid_email"),
        phone: yup.string().required("required_field").matches(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im, "invalid_phone"),
        postalcode: yup.string().required("required_field").max(16, "invalid_postalcode"),
        customerNumber: yup.string().when("$isCustomer", { is: true, then: (s: yup.StringSchema) => s.required("required_field") }),
        dateOfBirth: yup.date()
            .nullable()
            .when("$isCustomer", { 
            is: false, 
            then: (s: yup.DateSchema) => 
                s.required()
                .max(new Date(), "invalid_date")
                .min(new Date(1900, 1, 1), "invalid_date"),
            otherwise: (s: yup.DateSchema) => s.optional() }),
        // rszNumber: yup.string().when(
        //     "$isCustomer", {
        //     is: false,
        //     then: (s: yup.StringSchema) => s.required("required_field").test("rszCheck", "invalid_social_security_number", (value: string) => {
        //         if (value === "") {
        //             return true;
        //         }
        //         const matches = value.match(this.nationalSecurityNumberRegex);

        //         if (matches && matches.length) {
        //             const currentYear = new Date().getFullYear() - 2000;
        //             const year = matches[1];
        //             const month = matches[2];
        //             const day = matches[3];
        //             const serial = matches[4];
        //             const controllNumberA = +matches[5];

        //             let identificationNumber = +`${year}${month}${day}${serial}`;
        //             if (+year <= currentYear) {
        //                 // For persons born after 2000 the number 2 has to be added in front
        //                 identificationNumber = +`2${identificationNumber}`;
        //             }

        //             const controllNumberB = 97 - (identificationNumber % 97);
        //             if (controllNumberA === controllNumberB) {
        //                 return true;
        //             }
        //         }
        //         return false;
        //     })
        // }),
        consent: yup.bool().oneOf([true], 'consent_not_given')
    });

    public async validateProperty(values: ContactFormEntry, isNewCustomer: boolean, propertyName: string): Promise<FormError[]> {
        let errors: FormError[] = [];
        try {
            await this.validationSchema.validateSyncAt(propertyName, values, { abortEarly: false, context: { isCustomer: !isNewCustomer }  });
        }
        catch (err) {
            if (err.errors.length > 0) {
                errors = [new FormError("subject", [this.translatedErrorMessages[err.errors[0]]])];
            }
        }

        return errors;
    }

    public async validate(values: ContactFormEntry, isNewCustomer: boolean): Promise<FormError[]> {
        let errors: FormError[] = [];

        try {
            await this.validationSchema.validateSync(values, { abortEarly: false, context: { isCustomer: !isNewCustomer } });
        }
        catch (err) {
            errors = this.getFormErrorsFromValidationError(err);
        }
        return errors;
    }

    private getFormErrorsFromValidationError(validationError: any, formErrors?: FormError[]): FormError[] {
        formErrors = formErrors ?? [];
        if (validationError) {
            if (validationError.path) {
                if (formErrors.filter(err => { return err.field === validationError.path }).length === 0) {
                    const translatedMessage = this.translatedErrorMessages[validationError.message];
                    formErrors.push(new FormError(validationError.path, [translatedMessage]));
                }
            }

            if (validationError.inner && validationError.inner.length > 0) {
                for (let innerError of validationError.inner) {
                    this.getFormErrorsFromValidationError(innerError, formErrors);
                }
            }
        }
        return formErrors;
    }
}